import { createDialog } from '@/infrastructure/decorators/dialog';
export function createConfirmShareToPublicService() {
    return createDialog(() => import('./components/ConfirmShareToPublicDialog.vue'));
}
